import moment from "moment";
import { dateFormat, deepCopy, } from "../../../app/util";
import _ from "lodash";

export const itIsPricingModel3Data = (pricingSeasons) => {
    if (
        pricingSeasons &&
        (pricingSeasons.initial.length > 0 && pricingSeasons.initial[0].pricingModel === 3) ||
        (pricingSeasons.updated.length > 0 && pricingSeasons.updated[0].pricingModel === 3)
    ) {
        pricingSeasons = deepCopy(pricingSeasons);
    }
    else {
        pricingSeasons = { initial: [], updated: [] };
    }

    return pricingSeasons;
};

export const filterSeasons = (pricingSeasons) => {
    const activeSeasons = [];
    const inactiveSeasons = [];
    const expiredSeasons = [];

    if (pricingSeasons && pricingSeasons.initial && pricingSeasons.updated) {

        // Convert back to array
        const result = combinedSeasons(pricingSeasons);

        result.forEach((season) => {
            if (season.status === "active") {
                activeSeasons.push(season);
            } else if (season.status === "inactive") {
                inactiveSeasons.push(season);
            } else if (season.status === "expired") {
                expiredSeasons.push(season);
            }
        });
    }

    return { activeSeasons, inactiveSeasons, expiredSeasons }
}

export function formatSeasonDateRange(from, until) {
    if (!from || !until) return "—";

    const start = new Date(from);
    const end = new Date(until);
    const sameYear = start.getFullYear() === end.getFullYear();

    // Format both sides properly
    const startFmt = dateFormat(start, "ddd, MMM DD");
    const endFmt = dateFormat(end, "ddd, MMM DD");

    if (sameYear) {
        return `${startFmt} - ${endFmt}, ${start.getFullYear()}`;
    }
    else {
        return `${dateFormat(start, "ddd, MMM DD, YYYY")} - ${dateFormat(end, "ddd, MMM DD, YYYY")}`;
    }
}

export function getUsedDateFromSeasons(seasons, curSeason) {
    const usedDate = [];
    const useDateYYYYMMDD = [];
    seasons.forEach((season) => {
        if (season.isDefault === false) {
            // check if curSeason date range is similar to season date range
            if (curSeason.plan_period.effective_date_range.from === season.plan_period.effective_date_range.from
                && curSeason.plan_period.effective_date_range.until === season.plan_period.effective_date_range.until) {
                return;
            }
            const { from, until } = season.plan_period.effective_date_range;
            let currentDate = moment(from);
            let endDate = moment(until);

            while (currentDate.isSameOrBefore(endDate, 'day')) {
                usedDate.push(new Date(currentDate.format('YYYY-MM-DD')));
                useDateYYYYMMDD.push(currentDate.format('YYYY-MM-DD'));
                currentDate.add(1, 'day');
            }
        }
    });
    return { usedDate, useDateYYYYMMDD };
}
const safeDelete = (obj, prop) => {
    if (obj && Object.prototype.hasOwnProperty.call(obj, prop)) {
        delete obj[prop];
    }
};
export function checkHasError(initialSeasonParam, editedSeasonParam, pricingSeasons, inventoryRoomSettings = []) {
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const rooms = Object.keys(editedSeasonParam.dependent_room_type.room_type);
    //stringify initialSeason and season to find changes
    const initialSeason = deepCopy(initialSeasonParam);
    const editedSeason = deepCopy(editedSeasonParam);
    //removeNotEditableField
    ['last_status_edited_by', 'last_status_edited_on', 'last_edited_by', 'last_edited_on'].forEach(prop => {
        safeDelete(editedSeason, prop);
        safeDelete(initialSeason, prop);
    });

    const initialSeasonStr = JSON.stringify(initialSeason);
    const editedSeasonStr = JSON.stringify(editedSeason);
    //debugger;

    // check season do not have empty string or null
    if (editedSeasonStr.includes('null') || editedSeasonStr.includes('""') || editedSeasonStr.includes("''")) {
        return 'Please fill in all fields.';
    }

    const { activeSeasons, inactiveSeasons } = filterSeasons(pricingSeasons);
    const searchableSeasons = [...activeSeasons, ...inactiveSeasons];
    const duplicateSeason = hasDuplicateSeasonName(searchableSeasons, editedSeason.id, editedSeason.plan_name)

    if (duplicateSeason) {
        return 'Name is already taken. Please choose another.';
    }

    //  Find any min is grater then max then return message
    const errorInDay = rooms.map(room => {
        let result = false;
        days.find((day) => {

            if (editedSeason.dependent_room_type.room_type[room][day].min > editedSeason.dependent_room_type.room_type[room][day].max) {
                const { display_name } = inventoryRoomSettings.find(item => item.room_lodgiq_code === room) || {};
                result = display_name + ' on ' + day;
            }

        })
        return result;
    })

    if (errorInDay.toString().includes('on')) {
        return `Floor value must be less than Ceiling value for ${errorInDay.find(d => d !== false)}.`
    }

    return false
}
export function checkDateOverlapError(editedSeason, pricingSeasons, dummySeason) {
    const { activeSeasons, inactiveSeasons } = filterSeasons(pricingSeasons);
    // check editedSeason date range is not overlapping with other seasons
    const { usedDate, useDateYYYYMMDD } = getUsedDateFromSeasons(activeSeasons, dummySeason);
    // EditedDateRange Full date range array editedSeason.plan_period.effective_date_range.from to editedSeason.plan_period.effective_date_range.until
    const editedDateRange = [];
    let currentDate = moment(editedSeason.plan_period.effective_date_range.from);
    let endDate = moment(editedSeason.plan_period.effective_date_range.until);

    while (currentDate.isSameOrBefore(endDate, 'day')) {
        editedDateRange.push(currentDate.format('YYYY-MM-DD'));
        currentDate.add(1, 'day');
    }

    if (useDateYYYYMMDD.some((d) => editedDateRange.includes(d))) {
        return 'This date range is already used by another active season. Please choose another date range.';
    }
    return false;
}

export function hasDuplicateSeasonName(searchableSeasons, seasonId, planName) {
    return searchableSeasons.some((s) => {
        if (s.id === seasonId) return false;
        return s.plan_name.toLowerCase() === planName.toLowerCase();
    });
}

export function generateUniqueSeasonName(planName, searchableSeasons) {
    const lowerNames = searchableSeasons.map(s => s.plan_name.toLowerCase());

    let counter = 1;
    let newName = `Copy of ${planName}`;

    while (lowerNames.includes(newName.toLowerCase())) {
        counter++;
        newName = `Copy (${counter}) of ${planName}`;
    }

    return newName; // Copy of, Copy (2) of, Copy (3) of etc
}

export const generateDefaultPricingSeason = (inventoryRoomSettings = [], defaultRatePlanCode = '') => {
    const inventoryRoomCodes = [];
    let baseRoomLodgiqCode = '';
    let baseRoomDisplayName = '';
    let rate_plan = defaultRatePlanCode;
    inventoryRoomSettings.map((item) => {
        inventoryRoomCodes.push(item.room_lodgiq_code);
        //if (!item.is_base) inventoryRoomCodes.push(item.room_lodgiq_code);
        if (item.is_base) {
            baseRoomDisplayName = item.display_name;
            baseRoomLodgiqCode = item.room_lodgiq_code;
        }
    });
    //Generate default pricing season structure
    const blankDowData = {
        "Sun": { min: null, max: null },
        "Mon": { min: null, max: null },
        "Tue": { min: null, max: null },
        "Wed": { min: null, max: null },
        "Thu": { min: null, max: null },
        "Fri": { min: null, max: null },
        "Sat": { min: null, max: null }
    }
    const default_pricing_season = {
        "id": 'new_' + crypto.randomUUID(),
        "isDefault": true,
        "plan_name": "Default Season",
        "status": "active",
        "plan_period": {
            "effective_date_range": {
                "from": moment().format("YYYY-MM-DD"),
                "until": "",
            }
        },
        "last_status_edited_by": '',
        "last_status_edited_on": '',
        "last_edited_by": '',
        "rate_plan": rate_plan, //"Base Rate Plan",
        "last_edited_on": '',
        "base_room": baseRoomDisplayName, //"put display_name from base room type",
        "base_room_lodgiq_code": baseRoomLodgiqCode,
        "dependent_room_type": {
            "room_type_differential": "absolute",
            "room_type": {}
        }
    };
    inventoryRoomCodes.forEach((code) => {
        const roomSetting = inventoryRoomSettings.find(item => item.room_lodgiq_code === code)
        default_pricing_season.dependent_room_type.room_type[code] = deepCopy(blankDowData);
        if (roomSetting && roomSetting.is_base) {
            default_pricing_season.base_room = roomSetting.display_name;
        }
    });
    return default_pricing_season;
};

export const combinedSeasons = (pricingSeasons) => {
    let result = [];
    if (pricingSeasons && pricingSeasons.initial && pricingSeasons.updated) {
        const seasonsInitial = deepCopy(pricingSeasons.initial);
        const seasonsUpdated = deepCopy(pricingSeasons.updated);

        // Convert seasonsInitial into a map for fast lookup & replace
        const map = new Map(seasonsInitial.map(item => [item.id, item]));

        // Insert or replace items from seasonsUpdated
        for (const item of seasonsUpdated) {
            map.set(item.id, item);
        }

        // Convert back to array
        result = Array.from(map.values());
    }
    return result;
}

